var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('User Roles'),"description":_vm.$t('From Here You Can Control The Users Permissions')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Search For A Group'),"emptyTableText":_vm.$t('there Are No Roles'),"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"buttonRole":_vm.$checkRole('roles_add'),"localData":true,"cloumns":[
          {
            column: 'name',
            title: _vm.$t('name'),
            type: 'text',
            sort: true
          },
          {
            column: 'users_count',
            title: _vm.$t('Users count'),
            type: 'text'
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'edit', role: _vm.$checkRole('roles_edit') },
              {
                name: 'delete',
                role: _vm.$checkRole('roles_delete')
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }